import {BOUGHT_PRODUCT} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import AppFunction from "../../../core/helpers/app/AppFunction";
import moment from "moment";
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {TENANT_MAIL_CHECK_URL} from "../../../common/Config/apiUrl";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                // cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('Redeem_Products'),
                url: BOUGHT_PRODUCT,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'custom-html',
                        key: 'title',
                        isVisible: true,
                        modifier: (title) => {
                            return title ? title: '-';
                        }
                    },
                    {
                        title: this.$t('description'),
                        type: 'custom-html',
                        key: 'product',
                        isVisible: true,
                        modifier: (product) => {
                            return product ? product.description : '-';
                        }
                    },
                    {
                        title: this.$t('price'),
                        type: 'custom-html',
                        key: 'product',
                        isVisible: true,
                        modifier: (product) => {
                            return product.price ?? '';
                        }
                    },
                    {
                        title: this.$t('quantity'),
                        type: 'custom-html',
                        key: 'quantity',
                        isVisible: true,
                        modifier: (quantity) => {
                            return quantity ?? 0;
                        }
                    },
                    {
                        title: this.$t('image'),
                        type: 'custom-html',
                        key: 'product',
                        isVisible: true,
                        modifier: (product) => {
                            return `<div style="background-image: url(${window.location.origin + product.image}); background-position: center; background-size: cover;width: 100%;height: 70px;border-radius: 5px;" />`;
                        }
                    },
                    {
                        title: this.$t('bought_at'),
                        type: 'custom-html',
                        key: 'bought_at',
                        isVisible: true,
                        modifier: (bought_at) => {
                            return moment(bought_at).format('YYYY-MM-DD');
                        }
                    },
                    {
                        title: this.$t('voucher_no'),
                        type: 'custom-html',
                        key: 'voucher_no',
                        isVisible: true,
                        modifier: (voucher_no) => {
                            return voucher_no ?? '';
                        }
                    },
                    {
                        title: this.$t('redeemed_at'),
                        type: 'custom-html',
                        key: 'redeemed_at',
                        isVisible: true,
                        modifier: (redeemed_at) => {
                            return redeemed_at ? moment(redeemed_at).format('YYYY-MM-DD') : 'Not yet';
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('Redeem'),
                        icon: 'gift',
                        key: "Redeem",
                        name: "redeem",
                        modifier: row => {
                            if (row.redeemed === 0) {
                                return this.$can('update_crms') &&
                                    (row.id !== window.user.id || this.$isAdmin() || this.$isTenantAdmin());
                            } else return null;
                        },
                    },
                    // {
                    //     title: this.$t('delete'),
                    //     icon: 'trash-2',
                    //     url: BOUGHT_PRODUCT,
                    //     type: 'modal',
                    //     component: 'app-confirmation-modal',
                    //     modalId: 'app-confirmation-modal',
                    //     name: 'delete',
                    //     modifier: row => {
                    //         return this.$can('delete_crms') && (row.id !== window.user.id || this.$isAdmin() || this.$isTenantAdmin());
                    //     },
                    // }
                ],
                // filters: [
                //     {
                //         title: this.$t('created'),
                //         type: "range-picker",
                //         key: "created_at",
                //         option: ["today", "thisMonth", "last7Days", "thisYear"]
                //     },
                //     {
                //         title: this.$t('name'),
                //         key: "name",
                //         type: "text",
                //     },
                // ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    created() {
        // this.checkMailSettings();
        // if (!this.selectedUrl) {
        //     this.checkEmployeeID();
        // }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {


            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            if (action.key === 'edit') {
            }

        },
        reloadShopTable() {
            this.isContextMenuOpen = false;
            this.$hub.$emit('redeem-product-table')
        },
    }
}